import { ProductCategory } from '@iota/inh-core-v1-management-client';
import { CompanyProductSelectionWithProduct } from 'src/app/store/entity-models';
import { PRODUCT_CARD_IMAGE_CATEGORIES } from 'src/app/shared/constants-and-enums/product-category';
import { ProductAttribute } from 'src/app/shared/constants-and-enums/attribute-types';
import { getAttributeFirstValue, getAttributeValueInDefaultLanguage } from 'src/app/shared/utils';
import { productCardImageUrl } from 'src/app/shared/utils/product-image.util';

export interface ProductCardLabels {
    name: string;
    subtitle: string;
}

export function isMockBasketProduct(selection: CompanyProductSelectionWithProduct): boolean {
    return selection?.product?.productCategory === ProductCategory.MOCK_BASKET_PRODUCT;
}

export function buildBackgroundImageUrl(selection: CompanyProductSelectionWithProduct): string {
    if (isMockBasketProduct(selection)) {
        return getAttributeFirstValue(selection, ProductAttribute.IMAGE_URL) ?? '';
    }

    return productCardImageUrl(selection?.product?.productCategory, PRODUCT_CARD_IMAGE_CATEGORIES);
}

export function buildLabels(selection: CompanyProductSelectionWithProduct, language: string): ProductCardLabels {
    if (!selection) {
        return { name: '', subtitle: '' };
    }

    if (isMockBasketProduct(selection)) {
        const customName = getAttributeValueInDefaultLanguage(selection, ProductAttribute.NAME, language);
        if (customName) {
            return { name: customName, subtitle: selection?.product?.name ?? '' };
        }
    }

    // NAME attribute from CPS is already merged/overridden by the backend
    return { name: getAttributeValueInDefaultLanguage(selection, ProductAttribute.NAME, language) ?? '', subtitle: '' };
}
